import { QueryClient } from "@tanstack/react-query";
const ONE_MONTH = 30 * 24 * 60 * 60 * 1000;
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: ONE_MONTH, // 1 month fresh
      cacheTime: ONE_MONTH,
      refetchOnWindowFocus: false,
    },
  },
});
